import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { List } from 'seedly-component-library';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { CommunityPageContext } from '../context/CommunityPageContext';
import useFeedList from '../hooks/useFeedList';
import ListItem from './ListItem';

const FeedSelectList = () => {
  const { pageType, setPageType } = useContext(CommunityPageContext);
  const router = useRouter();
  const feedList = useFeedList();

  const dataSource = feedList.map(feed => {
    const isActive = pageType === feed.value;
    const feedQuery = feed.query ? `/community${feed.query}` : '/community';

    return (
      <div
        key={feed.value}
        onClick={() => {
          setPageType(feed.value);
          mixpanel.track(trackedEvents.SidebarClicked, {
            param: `${feed.name.toLowerCase()}`,
          });
          router.push(feedQuery, feedQuery, { shallow: true });
        }}
        className="cursor-pointer"
        data-testid={`${feed.value}-feed-select`}
      >
        <ListItem icon={feed.icon} isActive={isActive} name={feed.name} />
      </div>
    );
  });

  return (
    <List
      dataSource={dataSource}
      headerSpacing="xs"
      listSpacing="xxs"
      width="100%"
      header={<p className="text-sm font-bold ml-2 mt-2">Feed</p>}
    />
  );
};

export default FeedSelectList;
